import jquery from "jquery";
import './assets/js/modernizr-3.6.0.min'
import './assets/js/plugins';
export default (window.$ = window.jQuery = jquery);
import 'bootstrap'